
import { mapGetters } from 'vuex';
import { apiHotSearchWords, apiDefaultSearchWords } from '@/api/pc';
import { cartList as apiCartList } from '@/api/goods/cart';
import { wholesaleCartList } from '@/api/wholesale';
export default {
	props: {},
	data() {
		return {
			searchType: 'goods',
			searchTypeText: '商品',
			keyword: '',
			hotSearchWords: [],
			defaultSearchWords: '',
			cartList: [],
			cartTotalPrice: 0,
			wholesaleCartList:[],
			wholesaleCartTotalPrice:0,
			wholesalePrice:0,
		};
	},
	components: {},
	computed: {
		...mapGetters(['wholesaleCartCount','cartCount', 'siteInfo', 'defaultGoodsImage', 'member'])
	},
	created() {
		this.keyword = this.$route.query.keyword || '';
		if (this.$route.name == 'street') this.searchType = 'shop';
		else this.searchType = 'goods';
		this.$store.dispatch('site/siteInfo');
		this.getHotSearchWords();
		this.getDefaultSearchWords();
		this.getWholesaleCartList();
		this.getCartList();
	},
	watch: {
		searchType() {
			this.searchTypeText = this.searchType == 'goods' ? '商品' : '店鋪';
		},
		$route(curr) {
			if (this.keyword !== curr.query.keyword) {
				this.keyword = curr.query.keyword;
			}
			if (this.$route.name == 'street') this.searchType = 'shop';
			else this.searchType = 'goods';
		},
		wholesaleCartCount(){
			if (this.member)	this.getWholesaleCartList();
		},
		cartCount() {
			if (this.member) this.getCartList();
		},
		member() {
			if (!this.member) {
				this.$store.commit('cart/SET_CART_COUNT', 0);
				this.cartList = [];
				this.cartTotalPrice = 0;

				this.$store.commit('wholesaleCart/SET_WHOLESALE_CART_COUNT', 0);
				this.wholesaleCartList = [];
				this.wholesaleCartTotalPrice = 0;
			}
		}
	},
	methods: {
		
		handleCommand(command) {
			this.searchType = command;
		},
		search() {
			if (this.searchType == 'goods') this.$router.push({ path: '/list', query: { keyword: this.keyword } });
			else this.$router.push({ path: '/street', query: { keyword: this.keyword } });
		},
		getHotSearchWords() {
			apiHotSearchWords({}).then(res => {
				if (res.code == 0 && res.data.words) {
					this.hotSearchWords = res.data.words.split('，');
				}
			});
		},
		getDefaultSearchWords() {
			apiDefaultSearchWords({}).then(res => {
				if (res.code == 0 && res.data.words) {
					this.defaultSearchWords = res.data.words;
				}
			});
		},
		getWholesaleCartList(){
			wholesaleCartList({})
				.then(res => {
					if (res.code == 0 && res.data) {
						this.wholesaleCartTotalPrice=0
						this.wholesaleCartList = res.data;
						this.wholesaleCartList.forEach(item => {
							let list=JSON.parse(item.price_json)
							for (var i = 0; i < list.length; i++) {
								if(item.num>=Number(list[i].num)){
									this.$set(item,'wholesalePrice',list[i].price)
								}
							}
							this.wholesaleCartTotalPrice += Number(item.wholesalePrice) * item.num;
						});

						this.wholesaleCartTotalPrice = this.wholesaleCartTotalPrice.toFixed(2);
					}
				})
				.catch(res => {});
		},
		// 獲取購物車數據
		getCartList() {
			
			apiCartList({})
				.then(res => {
					if (res.code == 0 && res.data) {
						this.cartTotalPrice=0
						this.cartList = res.data.cart_list;
						this.cartList.forEach(item => {
							this.cartTotalPrice += item.discount_price * item.num;
						});
						this.cartTotalPrice = this.cartTotalPrice.toFixed(2);
					}
				})
				.catch(res => {});
		},
		imageError(index) {
			this.cartList[index].sku_image = this.defaultGoodsImage;
		},
		//進貨單商品刪除
		wholesaleDeleteCart(index){
			this.$store.dispatch('wholesaleCart/delete_cart', {
					cart_id: this.wholesaleCartList[index].cart_id.toString()
				})
				.then(res => {
					if (res.code >= 0) {
						this.wholesaleCartList.splice(index, 1);
						this.$forceUpdate();
					}
				})
				.catch(err => {});
		},
		// 刪除單個購物車商品
		deleteCart(index) {
			this.$store
				.dispatch('cart/delete_cart', {
					cart_id: this.cartList[index].cart_id.toString()
				})
				.then(res => {
					if (res.code >= 0) {
						this.cartList.splice(index, 1);
						this.$forceUpdate();
					}
				})
				.catch(err => {});
		}
	}
};
